export default __webpack_public_path__ + "static/media/ER1_activations_XY.6d04141e.png";